import { Contact } from 'apps/wrapper/src/services/api-client/contact-api';
import { AppointmentRequestDetails } from 'apps/wrapper/src/services/appointment/types/appointment-request-details';
import { CancellationAppointment } from 'apps/wrapper/src/services/appointment/types/cancellation-appointment';
import { createContext } from 'react';

export interface CancellationRequestViewContextProps {
  isLoading: boolean;
  contact: Contact | undefined;
  isEditable: boolean;
  requestDetails: AppointmentRequestDetails;
  appointment: CancellationAppointment | undefined;
}

export const CancellationRequestViewContext = createContext<CancellationRequestViewContextProps>(null!);
